//import swal from 'sweetalert2';
import ResourceSvc from '@/services/resource.svc.js';
import store from '@/services/store';
import GoogleMapsLoader from 'google-maps'
const svc = new ResourceSvc();

export default {
    name: 'CourseDetailsTab',
    components: {
    },
    computed: {
        courseId() {
            return this.$route.params.id;
        },
        dateString() {
            return this.general.startDate.toString().substring(0, this.general.startDate.toString().indexOf('GMT') - 4);
        },
        dateEndString() {
            if (this.general.endDate != null) {
                return this.general.endDate.toString().substring(0, this.general.endDate.toString().indexOf('GMT') - 4);
            }
            else {
                return "";
            }
        }
    },
    data() {
        return {
            map: null,
            general: {
                id: 0,
                name: '',
                town: '',
                county: '',
                url: '',
                status: 1,
                type: 1,
                typeString: '',
                durationInHours: 0,
                //ToDo: new Date() = should be taken from General.Now
                startDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
                endDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
                ownerName: '',
                ownerEmail: '',
                refundPolicy: '',
                contactPersonName: '',
                contactPersonEmail: ''
            },
            pricing: {
                priceMembers: 0,
                priceNonMembers: 0,
                maxCountAttendants: 0,
                currentCountAttendants: 0
            },
            firstColClass: 'col-md-5 col-sm-5',
            secondColClass: 'col-md-7 col-sm-7',
            isAllowedRegistration: false,
            notAllowedRegistrationReason: '',
            isRedirectToBillingAllowed: false,
            isCancelled: false
        };
    },
    methods: {
        loadData() {
            var self = this;
            svc.getCourseForUser(self.general.id).then(response => {
                var allData = response.body;
                if (allData !== null) {
                    if (allData.isSuccess == false) {
                        self.backToCourses();
                        return;
                    }

                    self.isAllowedRegistration = allData.isAllowedRegistration;
                    if (!allData.isAllowedRegistration) {
                        self.notAllowedRegistrationReason = allData.message;
                        self.isRedirectToBillingAllowed = allData.isRedirectToBillingAllowed;
                        self.isCancelled = allData.isCancelled;
                    }

                    self.general.id = allData.generalDetails.id;
                    self.general.name = allData.generalDetails.name;
                    self.general.url = allData.generalDetails.url;
                    self.general.county = allData.generalDetails.county;
                    self.setStartDate(allData.generalDetails.dateStart);
                    self.setEndDate(allData.generalDetails.dateEnd);
                    self.general.town = allData.generalDetails.town;
                    self.general.status = allData.generalDetails.status;
                    self.general.type = allData.generalDetails.type;
                    self.general.durationInHours = allData.generalDetails.durationInHours;
                    self.general.ownerName = allData.generalDetails.ownerName;
                    self.general.ownerEmail = allData.generalDetails.ownerEmail;
                    self.general.typeString = allData.generalDetails.typeString;
                    self.general.refundPolicy = allData.generalDetails.refundPolicy;
                    self.general.contactPersonName = allData.generalDetails.contactPersonName;
                    self.general.contactPersonEmail = allData.generalDetails.contactPersonEmail;

                    self.pricing.maxCountAttendants = allData.generalDetails.maxCountAttendants;
                    self.pricing.currentCountAttendants = allData.generalDetails.countAttendants;
                    self.pricing.priceNonMembers = allData.pricingDetails.priceNonMembers;
                    self.pricing.priceMembers = allData.pricingDetails.priceMembers;

                    self.general.latitude = allData.generalDetails.latitude;
                    self.general.longtitude = allData.generalDetails.longtitude;

                    self.description = allData.generalDetails.description;
                } else {
                    self.badRequestSwal();
                }
            },
                response => {
                    self.badRequestSwal();
                });
        },
        backToCourses() {
            window.history.back();
        },
        setStartDate(value) {
            this.general.startDate = new Date(value);
        },
        setEndDate(value) {
            if (value && new Date(value) > this.general.startDate) {
                this.general.endDate = new Date(value);
            }
        },
        badRequestSwal(message) {
            var self = this;
            if (!message) {
                message = 'Something went wrong. Incorrect request!';
            }
            this.$notify({
                message: message,
                type: 'danger'
            });

            setTimeout(function () {
                self.$router.push({ path: '/courses' });
            }, 3000);

            //if (!message) {
            //    message = 'Something went wrong. Incorrect request!';
            //}
            //swal({
            //    title: message,
            //    text: 'Automatic closing in 3 seconds',
            //    timer: 3000,
            //    showConfirmButton: true,
            //    confirmButtonClass: 'btn btn-warning btn-fill',
            //    type: 'warning'
            //});
        },
        initRegularMap(google) {
            var markLat = 0;
            var markLng = 0;

            if (this.general.longtitude !== null) {
                markLat = this.general.longtitude;
            } else {
                markLat = -6.266155;
            }
            if (this.general.latitude !== null) {
                markLng = this.general.latitude;
            } else {
                markLng = 53.350140;
            }

            const myLatlng = new window.google.maps.LatLng(53.350140, -6.266155)

            const mapOptions = {
                zoom: 8,
                center: myLatlng,
                scrollwheel: false
            }
            this.map = null;
            var el = document.getElementById('regularMap');

            if (el !== null) {
                this.initMap(el, mapOptions, markLng, markLat);
            }
            else {
                var self = this;
                setTimeout(function () {
                    GoogleMapsLoader.load((google) => {
                        self.initRegularMap(google)
                    })
                }, 400)
            }
        },
        initMap(el, mapOptions, markLng, markLat) {
            this.map = new window.google.maps.Map(el, mapOptions)

            var markLatlng = new window.google.maps.LatLng(markLng, markLat)

            const marker = new window.google.maps.Marker({
                position: markLatlng,
                title: 'Regular Map!'
            });
            this.marker = marker;
            marker.setMap(this.map)
            this.map.setCenter(markLatlng);
        }
    },
    created() {
        GoogleMapsLoader.KEY = process.env.GoogleApiKey;

        this.general.id = this.courseId;
        this.loadData();
        // if (this.map === null)
        GoogleMapsLoader.load((google) => {
            this.initRegularMap(google)
        })
    },
    mounted() {
        var user = store.getters.getCurrentUser;
        if (user && user.roles && user.roles.length) {
            if (user.roles.some(function (el) { return el === "Admin"; })) {
                this.$router.push("admin/courses");
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/courses/course-details/details-tab/details-tab.js